import React from "react";
import { Table, TableBody } from "@mui/material";
import { TransferTableAmountRow, TransferTableHeaderRow, TransferTableTotalRow } from "./components/TransferTableRow";
import { blue } from "@mui/material/colors";

// 買掛振替表
export default function PurchaseTransferTable({purchaseTransferInfo}) {

  return (
    <Table>
      <TableBody>
        <HeaderRow />
        {
          getPurchaseTransferRowData(purchaseTransferInfo).map((rowData) => AmountRow({rowData}))
        }
        <TotalRow rowData={getPurchaseTransferTotalData(purchaseTransferInfo)} />
      </TableBody>
    </Table>
  )
}

const bgcolors = {
  header: blue[300],
  name: blue[100],
  totalName: blue[200],
  subjectName: blue[50],
  totalAmount: blue[100]
}

const HeaderRow = () => (
  <TransferTableHeaderRow
    name="買掛仕分け"
    requiredSubject
    bgcolor={bgcolors.header}
  />
);

const AmountRow = ({rowData}) => {
  return (
    <TransferTableAmountRow
      nameBgcolor={bgcolors.name}
      subjectBgcolor={bgcolors.subjectName}
      {...rowData}
    />
  )
};

const TotalRow = ({rowData}) => {
  return (
    <TransferTableTotalRow
      nameBgcolor={bgcolors.totalName}
      amountBgcolor={bgcolors.totalAmount}
      {...rowData}
    />
  )
};

const getPurchaseTransferRowData = (purchaseTransferInfo) => ([
  {
    key: "purchaseTransfer_A",
    index: "A.",
    name: "受託　 軽減税率対象 仕入",
    debitSubject: "1013 仕入",
    debitAmount : purchaseTransferInfo ? purchaseTransferInfo.entrustedPurchasePriceForReducedTax : null,
  }, {
    key: "purchaseTransfer_B",
    index: "B.",
    name: "　　　 普通税率　　 仕入",
    debitSubject: "1013 仕入",
    debitAmount: purchaseTransferInfo ? purchaseTransferInfo.entrustedPurchasePriceForRegularTax : null,
  },{
    key: "purchaseTransfer_C",
    index: "C.",
    name: "受託外 軽減税率対象 仕入",
    debitSubject: "1013 仕入",
    debitAmount: purchaseTransferInfo ? purchaseTransferInfo.nonEntrustedPurchasePriceForReducedTax : null,
  },{
    key: "purchaseTransfer_D",
    index: "D.",
    name: "　　　 普通税率　　 仕入",
    debitSubject: "1013 仕入",
    debitAmount: purchaseTransferInfo ? purchaseTransferInfo.nonEntrustedPurchasePriceForRegularTax : null,
  },{
    key: "purchaseTransfer_E",
    index: "E.",
    name: "　　　 免税　　　　 仕入",
    debitSubject: "1013 仕入",
    debitAmount: purchaseTransferInfo ? purchaseTransferInfo.taxFreePurchasePrice : null,
  },{
    key: "purchaseTransfer_F",
    index: "F.",
    name: "販売手数料・運賃・伝票代他",
    creditSubject: "3011 売上",
    creditAmount: purchaseTransferInfo ? purchaseTransferInfo.totalFees : null,
  },{
    key: "purchaseTransfer_G",
    index: "G.",
    name: "軽減税率対象 買掛",
    creditSubject: "2044 買掛金",
    creditAmount: purchaseTransferInfo ? purchaseTransferInfo.netPurchasePriceForReducedTax : null,
  },{
    key: "purchaseTransfer_H",
    index: "H.",
    name: "普通税率　　 買掛",
    creditSubject: "2044 買掛金",
    creditAmount: purchaseTransferInfo ? purchaseTransferInfo.netPurchasePriceForRegularTax : null,
  }
]);

const getPurchaseTransferTotalData = (purchaseTransferInfo) => ({
  debitAmount : purchaseTransferInfo ? purchaseTransferInfo.totalDebitPrice : null,
  creditAmount : purchaseTransferInfo ? purchaseTransferInfo.totalCreditPrice : null,
});
